import { apiClient } from "../lib/apiClient";
import type { EventRecord, EventStatus, EventAssignment, EventAssignmentRole } from "../types";

export interface EventInput {
  courseId: string;
  name: string;
  description?: string | null;
  eventDate: string;
  startTime: string;
  endTime: string;
  location: string;
  capacity?: number | null;
  status?: EventStatus;
  whatsappTemplate?: string | null;
}

export async function listEvents(): Promise<EventRecord[]> {
  const { data } = await apiClient.get<{ events: EventRecord[] }>("/events");
  return data.events;
}

export async function getEvent(id: string): Promise<{ event: EventRecord; myRoleInEvent: EventAssignmentRole | null }> {
  const { data } = await apiClient.get<{ event: EventRecord; myRoleInEvent: EventAssignmentRole | null }>(`/events/${id}`);
  return data;
}

export async function createEvent(input: EventInput): Promise<EventRecord> {
  const { data } = await apiClient.post<{ event: EventRecord }>("/events", input);
  return data.event;
}

export async function updateEvent(id: string, input: Partial<EventInput>): Promise<EventRecord> {
  const { data } = await apiClient.patch<{ event: EventRecord }>(`/events/${id}`, input);
  return data.event;
}

export async function cancelEvent(id: string): Promise<void> {
  await apiClient.delete(`/events/${id}`);
}

export async function listAssignments(eventId: string): Promise<EventAssignment[]> {
  const { data } = await apiClient.get<{ assignments: EventAssignment[] }>(`/events/${eventId}/assignments`);
  return data.assignments;
}

export async function addAssignment(eventId: string, email: string, roleInEvent: EventAssignmentRole): Promise<EventAssignment> {
  const { data } = await apiClient.post<{ assignment: EventAssignment }>(`/events/${eventId}/assignments`, {
    email,
    roleInEvent,
  });
  return data.assignment;
}

export async function removeAssignment(eventId: string, userId: string): Promise<void> {
  await apiClient.delete(`/events/${eventId}/assignments/${userId}`);
}
